import reveals from "@/assets/blog/legends-awaken-new-reveals.webp.asset.json";
import jetragon from "@/assets/blog/legends-awaken-jetragon-art.webp.asset.json";
import frostallionNoct from "@/assets/blog/legends-awaken-frostallion-noct-art.webp.asset.json";
import cup from "@/assets/blog/palworld-grand-challengers-cup.webp.asset.json";
import masters from "@/assets/blog/palworld-masters-league.webp.asset.json";
import { parseBlocks } from "./blog-shared";

export const OCTOBER_TCG_BLOG_IMAGES = [
  { slug: "palworld-legends-awaken-new-artwork-reveals", images: [
    { url: reveals.url, alt: "Official Palworld Legends Awaken release visual featuring Broncherry, Saya, Selyne and Jetragon" },
    { url: jetragon.url, alt: "Official Jetragon illustration revealed for Palworld Legends Awaken" },
    { url: frostallionNoct.url, alt: "Official Frostallion Noct illustration revealed for Palworld Legends Awaken" },
  ] },
  { slug: "palworld-tcg-tournament-grand-challengers-cup", images: [
    { url: cup.url, alt: "Official Palworld Grand Challengers Cup October 2026 banner with Jormuntide Ignis and Lovander" },
    { url: masters.url, alt: "Official Palworld Masters League 26/27 tournament banner" },
  ] },
];

export function isOctoberTcgPost(slug: string) {
  return OCTOBER_TCG_BLOG_IMAGES.some((post) => post.slug === slug);
}

/** Structured answers are taken from the exact visible editorial FAQ text. */
export function octoberTcgFaq(slug: string, body: string) {
  if (!isOctoberTcgPost(slug)) return [];
  const blocks = parseBlocks(body);
  const start = blocks.findIndex((block) => block.kind === "h2" && block.text === "FAQ");
  if (start < 0) return [];
  return blocks.slice(start + 1).flatMap((block, index) => {
    const answer = blocks[start + index + 2];
    return block.kind === "h3" && answer?.kind === "p" ? [{ q: block.text, a: answer.text }] : [];
  });
}